import React from 'react'

const DataCoding = ({ height, width }) =>
  <svg version="1.1" id="datacoding" xmlns="http://www.w3.org/2000/svg" width={ width } height={ height } x="0px" y="0px" aria-labelledby="datacodingTitle" viewBox="0 0 337.4 280">
    <title id="datacodingTitle">Data Coding Icon</title>
    <g>
      <g>
        <path className="blue-icon" d="M249.7,47.7c-24.5-24.5-57.1-38-91.7-38c-34.6,0-67.2,13.5-91.7,38c-50.6,50.6-50.6,132.8,0,183.4
            c24.5,24.5,57.1,38,91.7,38c34.6,0,67.2-13.5,91.7-38c24.5-24.5,38-57.1,38-91.7S274.2,72.2,249.7,47.7z M76.7,58.2
            c21.7-21.7,50.6-33.7,81.3-33.7s59.6,12,81.3,33.7c17.1,17.1,28.2,38.7,32.1,62.2l-40.3,39.4c-3.8-2.2-8.2-3.4-12.9-3.4
            c-9.1,0-17.2,4.7-21.9,11.7l-59.2-18.6c0-0.2,0-0.3,0-0.5c0-14.5-11.8-26.3-26.3-26.3c-14.5,0-26.3,11.8-26.3,26.3
            c0,4.7,1.3,9.2,3.5,13l-31,32.2C33.3,150.6,39.9,95,76.7,58.2z M229.7,182.6c0,6.4-5.2,11.6-11.5,11.6c-6.4,0-11.6-5.2-11.6-11.6
            s5.2-11.6,11.6-11.6C224.5,171.1,229.7,176.3,229.7,182.6z M122.4,149c0,6.4-5.2,11.6-11.6,11.6c-6.4,0-11.6-5.2-11.6-11.6
            s5.2-11.6,11.6-11.6C117.2,137.4,122.4,142.6,122.4,149z M239.2,220.7c-21.7,21.7-50.6,33.7-81.3,33.7s-59.6-12-81.3-33.7
            c-4.3-4.3-8.2-8.9-11.7-13.7l33.6-34.8c3.7,1.9,7.8,3,12.2,3c9.1,0,17.2-4.7,21.9-11.7l59.2,18.6c0,0.2,0,0.3,0,0.5
            c0,14.5,11.8,26.3,26.3,26.3c14.5,0,26.3-11.8,26.3-26.3c0-4.5-1.1-8.7-3.1-12.4l31.5-30.8C272.9,170.2,260.9,199,239.2,220.7z"/>
      </g>
    </g>
    <path className="blue-icon" d="M159,0C81.7,0,19,62.7,19,140s62.7,140,140,140s140-62.7,140-140S236.3,0,159,0z M159,253.8
        c-62.7,0-113.8-51-113.8-113.8c0-62.7,51-113.8,113.8-113.8s113.8,51,113.8,113.8C272.7,202.7,221.7,253.8,159,253.8z"/>
  </svg>

export default DataCoding
